module.exports = __webpack_public_path__ + "assets/coin2fly.ff3efbc4.png";